/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OfferProductCable } from '../models/OfferProductCable';
import type { PaginatedOfferProductCableList } from '../models/PaginatedOfferProductCableList';
import type { PatchedOfferProductCable } from '../models/PatchedOfferProductCable';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OffersProductCablesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedOfferProductCableList
     * @throws ApiError
     */
    public offersProductCablesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedOfferProductCableList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-cables/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns OfferProductCable
     * @throws ApiError
     */
    public offersProductCablesCreate({
        requestBody,
    }: {
        requestBody: OfferProductCable,
    }): CancelablePromise<OfferProductCable> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/offers-product-cables/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductCable
     * @throws ApiError
     */
    public offersProductCablesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product cable.
         */
        id: number,
    }): CancelablePromise<OfferProductCable> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-cables/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns OfferProductCable
     * @throws ApiError
     */
    public offersProductCablesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product cable.
         */
        id: number,
        requestBody: OfferProductCable,
    }): CancelablePromise<OfferProductCable> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/offers-product-cables/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductCable
     * @throws ApiError
     */
    public offersProductCablesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product cable.
         */
        id: number,
        requestBody?: PatchedOfferProductCable,
    }): CancelablePromise<OfferProductCable> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/offers-product-cables/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public offersProductCablesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product cable.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/offers-product-cables/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
